import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideFaq, FaqFormData, FaqApiData } from './types'

export const useFaqUpdate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isUpdating, setIsUpdating] = useState(false)

  const updateFaq = async (
    id: string,
    formData: FaqApiData,
    setSlideFaq: (slideFaq: SlideFaq) => void,
    resetForm: (data: FaqFormData) => void
  ) => {
    if (!id) return

    setIsUpdating(true)

    try {
      const response = await apiClient.business.slideFaqUpdateUpdate({
        businessIdeaId: id,
        concerns: formData.concerns,
        faqs: formData.faqs,
      })

      if (response.data?.faq) {
        setSlideFaq(response.data.faq)
        showSnackBar(['FAQ・懸念点まとめを更新しました'], 'success')

        try {
          resetForm({
            concerns: JSON.parse(response.data.faq.concerns || '[]'),
            faqs: JSON.parse(response.data.faq.faqs || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['FAQ・懸念点まとめのデータの読み込みに失敗しました。'], 'error')
        }
      }
    } catch (e) {
      console.error('FAQ・懸念点まとめの更新に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updateFaq,
  }
}
